import {
  useLazyGetSqConfrimationLetterQuery,
  useLazySelectSqConfrimationLetterQuery,
  usePublishSqConfrimationLetterMutation,
  useSignSqConfrimationLetterMutation,
  useUpdateSqConfrimationLetterMutation,
  useLazyGetSqPublishConfrimationLetterQuery,
  useCreateNewVersionMutation
} from 'src/services/sqConfirmationLetterAPI';

export const useSqConfirmationLetter = () => {
  const [
    getSqConfrimationLetter,
    {
      data: sqConfrimationLetterData,
      isLoading: sqConfrimationLetterIsLoading,
      isError: sqConfrimationLetterIsError,
      error: sqConfrimationLetterError,
      isSuccess: sqConfrimationLetterIsSuccess
    }
  ] = useLazyGetSqConfrimationLetterQuery();

  const [
    getSqPublishConfrimationLetter,
    {
      data: sqPublishConfrimationLetterData,
      isLoading: sqPublishConfrimationLetterIsLoading,
      isError: sqPublishConfrimationLetterIsError,
      error: sqPublishConfrimationLetterError,
      isSuccess: sqPublishConfrimationLetterIsSuccess
    }
  ] = useLazyGetSqPublishConfrimationLetterQuery();

  const [
    selectSqConfrimationLetter,
    {
      data: selectSqConfrimationLetterData,
      isLoading: selectSqConfrimationLetterIsLoading,
      isError: selectSqConfrimationLetterIsError,
      error: selectSqConfrimationLetterError,
      isSuccess: selectSqConfrimationLetterIsSuccess
    }
  ] = useLazySelectSqConfrimationLetterQuery();

  const [
    updateSqConfrimationLetter,
    {
      data: updateSqConfrimationLetterData,
      isLoading: updateSqConfrimationLetterIsLoading,
      isError: updateSqConfrimationLetterIsError,
      error: updateSqConfrimationLetterError,
      isSuccess: updateSqConfrimationLetterIsSuccess
    }
  ] = useUpdateSqConfrimationLetterMutation();

  const [
    signSqConfrimationLetter,
    {
      data: signSqConfrimationLetterData,
      isLoading: signSqConfrimationLetterIsLoading,
      isError: signSqConfrimationLetterIsError,
      error: signSqConfrimationLetterError,
      isSuccess: signSqConfrimationLetterIsSuccess
    }
  ] = useSignSqConfrimationLetterMutation();

  const [
    publishSqConfrimationLetter,
    {
      data: publishSqConfrimationLetterData,
      isLoading: publishSqConfrimationLetterIsLoading,
      isError: publishSqConfrimationLetterIsError,
      error: publishSqConfrimationLetterError,
      isSuccess: publishSqConfrimationLetterIsSuccess
    }
  ] = usePublishSqConfrimationLetterMutation();
  const [
    createNewVersion,
    {
      data: createNewVersionData,
      isLoading: createNewVersionIsLoading,
      isError: createNewVersionIsError,
      error: createNewVersionError,
      isSuccess: createNewVersionIsSuccess
    }
  ] = useCreateNewVersionMutation();

  return {
    getSqConfrimationLetter,
    sqConfrimationLetterData,
    sqConfrimationLetterIsLoading,
    sqConfrimationLetterIsError,
    sqConfrimationLetterError,
    sqConfrimationLetterIsSuccess,
    selectSqConfrimationLetter,
    selectSqConfrimationLetterData,
    selectSqConfrimationLetterIsLoading,
    selectSqConfrimationLetterIsError,
    selectSqConfrimationLetterError,
    selectSqConfrimationLetterIsSuccess,
    updateSqConfrimationLetter,
    updateSqConfrimationLetterData,
    updateSqConfrimationLetterIsLoading,
    updateSqConfrimationLetterIsError,
    updateSqConfrimationLetterError,
    updateSqConfrimationLetterIsSuccess,
    publishSqConfrimationLetter,
    publishSqConfrimationLetterData,
    publishSqConfrimationLetterIsLoading,
    publishSqConfrimationLetterIsError,
    publishSqConfrimationLetterError,
    publishSqConfrimationLetterIsSuccess,
    signSqConfrimationLetter,
    signSqConfrimationLetterData,
    signSqConfrimationLetterIsLoading,
    signSqConfrimationLetterIsError,
    signSqConfrimationLetterError,
    signSqConfrimationLetterIsSuccess,
    sqPublishConfrimationLetterData,
    sqPublishConfrimationLetterIsLoading,
    sqPublishConfrimationLetterIsError,
    sqPublishConfrimationLetterError,
    sqPublishConfrimationLetterIsSuccess,
    getSqPublishConfrimationLetter,
    createNewVersion,
    createNewVersionData,
    createNewVersionIsLoading,
    createNewVersionIsError,
    createNewVersionError,
    createNewVersionIsSuccess
  };
};
